export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
            <path
                d="M15.1667 23.3335H25.5937M15.1667 34.6084H25.5937M30.4062 23.3335H40.8333M15.1667 29.1233H25.5937M30.4062 35.0002V29.889C30.4062 29.4661 30.7653 29.1233 31.2083 29.1233H40.8333"
                stroke="#F7A40A"
                strokeWidth="2.5"
                strokeLinecap="round"
            />
            <circle cx="28" cy="28" r="21" stroke="black" strokeWidth="2.5" />
        </svg>
    );
}
